/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {Alert, Button, CircularProgress, Grid, TextField, Typography} from "@mui/material";
import {CHECK_EMAIL, CHECK_PASSWORD} from "../../data/formats";

function RegisterView(props) {
    const {submit, isSubmitting, user, onEmailChange, onnNameChange, onPasswordAgainChange, onPasswordChange, info} = props
    return (
        <Grid container justifyContent={"center"} alignItems={"center"} alignContent={"center"} rowSpacing={2} marginX={"auto"} minHeight={"90vh"}>
            <Grid item xs={12}>
                <Typography variant={"h3"} component={"h1"} textAlign={"center"}>Registrácia</Typography>
            </Grid>
            <Grid item xs={12}>
                <form onSubmit={submit} style={{maxWidth: 250, margin: "0 auto"}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Alert severity={info.severity}>{info.text}</Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus={true}
                                id="name"
                                label="Meno"
                                type={"text"}
                                value={user.name}
                                onChange={onnNameChange}
                                disabled={isSubmitting}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                error={user.email !== "" && !CHECK_EMAIL.test(user.email)}
                                id="email"
                                label="Email"
                                type={"email"}
                                value={user.email}
                                onChange={onEmailChange}
                                disabled={isSubmitting}
                                fullWidth
                                helperText={user.email === "" || CHECK_EMAIL.test(user.email)? "":"Zlý formát emailu"}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                error={user.password !== "" && !CHECK_PASSWORD.test(user.password)}
                                id="password"
                                label="Heslo"
                                value={user.password}
                                type={"password"}
                                onChange={onPasswordChange}
                                disabled={isSubmitting}
                                fullWidth
                                helperText={user.password === "" || CHECK_PASSWORD.test(user.password) ?"" :"Heslo nespĺňa formát! znak, číslo, písmeno(veľké, malé)"}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                error={user.password !== "" && user.passwordAgain !== "" && user.password !== user.passwordAgain}
                                id="passwordAgain"
                                label="Heslo znova"
                                value={user.passwordAgain}
                                type={"password"}
                                onChange={onPasswordAgainChange}
                                disabled={isSubmitting}
                                fullWidth
                                helperText={user.password !== "" && user.passwordAgain !== user.password ? "Heslá sa nezhodujú!": ""}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth variant={"contained"} type="submit" disabled={isSubmitting} endIcon={isSubmitting ? <CircularProgress size={10}/> :""}>Zaregistrovať sa</Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>

        </Grid>
    );
}

export default RegisterView;